import zip from 'lodash/zip';
import errorsFactory from '../../../utils/errorsFactory';
import { getNormalizedKeyName } from '../../../utils/readXlsxFile.utils';
import { VALIDATION_ERRORS } from '../constants';

const getNormalizedColumnNames = worksheet => {
  const headers = [];
  const firstRow = worksheet.getRow(1);

  // Iterate through all columns in the first row
  for (let colNum = 1; colNum <= worksheet.columnCount; colNum++) {
    const cell = firstRow.getCell(colNum);
    if (cell.value) {
      const cellText = cell.text || String(cell.value);
      headers.push(getNormalizedKeyName(cellText));
    }
  }

  return headers;
};

const validateHeaders = ({ worksheet, columnHeaders, minColumnsNumber, maxColumnsNumber }) => {
  const normalizedColumnNames = getNormalizedColumnNames(worksheet);

  if (normalizedColumnNames.length < minColumnsNumber || normalizedColumnNames.length > maxColumnsNumber) {
    return 0;
  }

  const incorrectColumns = zip(normalizedColumnNames, columnHeaders)
    .slice(0, normalizedColumnNames.length)
    .map(([columnName, expectedColumnName]) => columnName === expectedColumnName)
    .map((isCorrect, columnIndex) => ({ isCorrect, columnIndex }))
    .filter(({ isCorrect }) => !isCorrect);

  if (incorrectColumns.length === normalizedColumnNames.length) {
    return 0;
  }

  return incorrectColumns[0]
    ? incorrectColumns[0].columnIndex + 1
    : null;
};

const columnHeadersValidator = (workbook, validationData) => {
  // Get first worksheet (ExcelJS uses worksheets array)
  const worksheet = workbook.worksheets[0];

  if (!validationData) {
    return;
  }

  const columnHeadersValidationResult = validateHeaders({
    worksheet,
    columnHeaders: validationData.columnHeaders,
    minColumnsNumber: validationData.minColumnsNumber,
    maxColumnsNumber: validationData.maxColumnsNumber,
  });

  if (columnHeadersValidationResult !== null) {
    throw errorsFactory.ValidationError(
      columnHeadersValidationResult === 0
        ? VALIDATION_ERRORS.COLUMN_HEADERS()
        : VALIDATION_ERRORS.COLUMN_HEADER_ERROR(columnHeadersValidationResult)
    );
  }
};

export default columnHeadersValidator;
